import React, { useState } from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import CustomTooltip from '../../components/tooltip/CustomTooltip';
import { useNavigate } from 'react-router-dom';

export default function StatCard({ cardMetaData }) {
  const navigate = useNavigate();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [clickedOpen, setClickedOpen] = useState(false);

  const renderIcon = () => {
    if (cardMetaData.icon && PhosphorIcons[cardMetaData.icon]) {
      return React.createElement(PhosphorIcons[cardMetaData.icon], {
        size: 18,
        color: cardMetaData.color,
      });
    }
    return null;
  };

  return (
    <CustomTooltip
      text={cardMetaData.tooltipText}
      open={isTooltipOpen || clickedOpen}
      onOpenChange={(val) => {
        if (!clickedOpen) {
          setIsTooltipOpen(val);
        }
      }}
    >
      <div className="border border-[var(--q3-stroke-light)] rounded-xl pl-4 py-4 md:pt-3 pr-3 min-h-[58px] md:h-[116px] cursor-pointer">
        <div className="flex flex-row md:flex-col justify-between h-full">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center">
              {renderIcon()}
              <div className="mx-2 w-full flex flex-col items-start md:flex-row text-[var(--q3-neutral-light)] text-xs font-semibold gap-1 md:gap-2">
                <span>{cardMetaData.title}</span>
                {cardMetaData.viewButton && (
                  <p
                    className="flex md:hidden underline flex-row text-xs !py-0 font-semibold items-center justify-center text-[var(--q3-accent-normal)] bg-[var(--q3-surface-default)]"
                    onClick={() => navigate(cardMetaData.buttonLink)}
                  >
                    VIEW
                    <PhosphorIcons.ArrowRightIcon />
                  </p>
                )}
              </div>
            </div>

            <PhosphorIcons.InfoIcon
              size={18}
              color="var(--q3-neutral-light)"
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                const next = !clickedOpen;
                setClickedOpen(next);
                setIsTooltipOpen(next);
              }}
            />
          </div>

          <div className="flex flex-row justify-between items-center">
            <p className="text-[var(--q3-neutral-default)] font-bold text-xl md:text-4xl">
              {cardMetaData.numerator}
              {cardMetaData.isPercentage && '%'}
              {cardMetaData.denominator && (
                <span className="text-[var(--q3-neutral-light)] text-sm">
                  {!cardMetaData.isTime && '/'}
                  {cardMetaData.denominator}
                </span>
              )}
            </p>
            {cardMetaData.viewButton && (
              <Button
                className="hidden md:flex flex-row text-xs !py-0 font-semibold items-center justify-center rounded-full shadow-none text-[var(--q3-neutral-default)] border border-[var(--q3-stroke-light)] bg-[var(--q3-surface-default)] group transition-colors duration-300 hover:bg-[var(--q3-surface-dim)]"
                onClick={() => navigate(cardMetaData.buttonLink)}
              >
                View
                <PhosphorIcons.CaretRightIcon className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </CustomTooltip>
  );
}
